export enum ReferralStatus {
  IN_PROGRESS = "In Progress",
  NOT_ONBOARDED = "Not Onboarded",
  ONBOARDED = "Onboarded",
  EXISTING_CLIENT = "Existing Client",
}

export enum ReferralCategory {
  EMPLOYEE = "Employee",
  TECHNICIAN = "Technician",
  DISTRIBUTOR = "Distributor",
}

export enum ReferralAction {
  PENDING = "Pending",
  ACCEPTED = "Accepted",
  REJECTED = "Rejected",
  ENDED = "Ended",
}

export enum IncentiveType {
  COMMISSION = "Commission",
  PER_CASE = "Per Case",
}

export enum ReferrerRole {
  REFERRER = "referrer",
  CLIENT_ID_REFERRER = "client_id_referrer",
}
